import { Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { CloseButton, useMinimalsTheme } from '@tom-ui/ui'
import { MAX_INT32_VALUE } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { YardBlockWithOccupancies } from '../../models/yard-view.model'
import { BlockHeaderNavigator } from './BlockHeaderNavigator'
import { MaxStackHeight } from './MaxStackHeight'

interface Props {
  selectedBay?: number
  selectedRow?: number
  yardBlock?: YardBlockWithOccupancies
  onClose: () => void
  onBayChange?: (bay: number) => void
  onRowChange?: (row: number) => void
}

export const YardBlockContainerDetailsHeader = observer(
  ({ selectedBay, selectedRow, yardBlock, onClose, onBayChange, onRowChange }: Props) => {
    const theme = useMinimalsTheme()
    const { t } = useTranslate()

    return (
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        padding={theme.customSpacing.s}
        width='100%'
        borderBottom={`1px solid ${theme.palette.grey[300]}`}
      >
        <Stack direction='row' alignItems='center' gap={theme.customSpacing.s}>
          <Typography variant='subtitle1'>{yardBlock?.name}</Typography>

          {selectedBay !== undefined && yardBlock?.bayNames && (
            <>
              <Typography variant='subtitle1'>/</Typography>
              {onBayChange ? (
                <BlockHeaderNavigator
                  names={yardBlock.bayNames}
                  selectedIndex={selectedBay}
                  label={t('bay', 'Bay')}
                  onChange={onBayChange}
                />
              ) : (
                <Typography variant='subtitle1'>
                  {t('bay', 'Bay')} {selectedBay}
                </Typography>
              )}
            </>
          )}

          {selectedRow !== undefined && yardBlock?.rowNames && (
            <>
              <Typography variant='subtitle1'>/</Typography>
              {onRowChange ? (
                <BlockHeaderNavigator
                  names={yardBlock.rowNames}
                  selectedIndex={selectedRow}
                  label={t('row', 'Row')}
                  onChange={onRowChange}
                />
              ) : (
                <Typography variant='subtitle1'>
                  {t('row', 'Row')} {selectedRow}
                </Typography>
              )}
            </>
          )}

          <MaxStackHeight
            configAreas={yardBlock?.configAreas ?? []}
            minBay={selectedBay ?? 1}
            maxBay={selectedBay ?? MAX_INT32_VALUE}
            minRow={selectedRow ?? 1}
            maxRow={selectedRow ?? MAX_INT32_VALUE}
          />
        </Stack>

        <CloseButton onClose={onClose} />
      </Stack>
    )
  },
)
